module.exports = __webpack_public_path__ + "static/media/location_san_diego.b0e45886.jpg";